import React, { useCallback, useEffect, useState } from "react";
import styles from "./StoreFront.module.scss";
import StoreTabSelector from "./layout/StoreTabSelector";
import ShopByLayout from "./components/shop-by-layout/ShopByLayout";
import ProductItem from "./components/product-item/ProductItem";
import NewDeals from "./components/new-deals/NewDeals";
import { Category } from "../../model/solar-product/category";
import categoryService from "../../httpService/CategoryService";
import { toast } from "react-toastify";
import CategoryItem from "./components/category-item/CategoryItem";
import solarProductService from "../../httpService/SolarProductService";
import { CategoryWithProduct } from "../../model/solar-product/category-with-product";
import { BounceLoader } from "react-spinners";
import SignInOrRegister from "./components/sign-in-or-register/SignInOrRegister";
import StoreBanner from "./components/store-banner/StoreBanner";
import { SolarProductObject } from "../../model/solar-product/solar-product-with-recommendations";

type Props = {};

const StoreFront: React.FC<Props> = (props: Props) => {
	const [loading1, setLoading1] = useState(false);
	const [loading2, setLoading2] = useState(false);
	const [categories, setCategories] = useState<Category[]>([]);
	const [productsByCategories, setProductsByCategories] = useState<CategoryWithProduct[]>([]);

	const fetchCategories = useCallback(async () => {
		try {
			setLoading1(true);
			const response = await categoryService.get();

			const data = response.data as any;

			setCategories(data.categories);

		} catch (error) {
			toast.error("Something went wrong while fetching Categories");
		} finally {
			setLoading1(false);
		}
	}, [categoryService]);

	const fetchProductsByCategories = useCallback(async () => {
		try {
			setLoading2(true);
			const response = await solarProductService.getStoreProductsByCategories();

			const data = response.data as any;

			setProductsByCategories(data.productsByCategories);
		} catch (error) {
			toast.error("Something went wrong while fetching Products in Categories");
		} finally {
			setLoading2(false);
		}
	}, [solarProductService]);

	useEffect(() => {
		fetchCategories();
	}, [fetchCategories]);

	useEffect(() => {
		fetchProductsByCategories();
	}, [fetchProductsByCategories]);

	const updateProductWishlistStatus = (product: SolarProductObject, productId: string, isInWishlist: boolean) => {
		if (product?.solarProduct?.id === productId) {
			return {
				...product,
				solarProduct: { ...product.solarProduct, isWishlisted: isInWishlist },
			};
		}
		return product;
	};
	
	const updateCategoryProducts = (categoryWithProduct: CategoryWithProduct, productId: string, isInWishlist: boolean) => {
		return {
			...categoryWithProduct,
			productsAndAvailableOffers: categoryWithProduct.productsAndAvailableOffers?.map(product =>
				updateProductWishlistStatus(product, productId, isInWishlist)
			),
		};
	};
	
	const handleWishlistChange = (productId: string, isInWishlist: boolean) => {
		setProductsByCategories(prevProductsByCategories =>
			prevProductsByCategories.map(categoryWithProduct =>
				updateCategoryProducts(categoryWithProduct, productId, isInWishlist)
			)
		);
	};

	return (
		<>
			<StoreTabSelector />
			<div className={styles.storeContainer}>
				<div className={styles.innerContainer}>
					<div className={styles.topFlexDiv}>
						{/* <SignInOrRegister /> */}
						<StoreBanner />
					</div>
					{loading1 && loading2 ? (
						<BounceLoader size={200} color="#DE841B" />
					) : (
						<>
							<ShopByLayout hideButtons label="">
								<NewDeals />
							</ShopByLayout>
							<ShopByLayout hideButtons label="Shop by Categories">
								{categories.map((x) => (
									<CategoryItem key={x.id} category={x} />
								))}
							</ShopByLayout>
							{productsByCategories.map((x) => (
								<ShopByLayout key={x.category?.id} label={`Shop by ${x.category.name}`} navigateUrl={`/store/category/${x.category.name}`}>
									{x.productsAndAvailableOffers?.map((item, i) => (
										<ProductItem key={`${i}-item`} solarProduct={item} onWishlistChange={handleWishlistChange} />
									))}
								</ShopByLayout>
							))}
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default StoreFront;
